<div class="three-panel-container">
  @if (showLeftPanel()) {
    <aside class="panel left-panel" [class.collapsed]="isLeftCollapsed">
      <div class="panel-content-wrapper">
        <ng-content select="[left-panel]"></ng-content>
      </div>
      @if (isLeftCollapsed) {
        <button
          mat-icon-button
          class="toggle-button"
          (click)="toggleLeft()"
          [title]="isLeftCollapsed ? 'Show panel' : 'Hide panel'"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </aside>
  }

  <main class="panel center-panel">
    <ng-content select="[center-panel]"></ng-content>
  </main>

  @if (showRightPanel()) {
    <aside class="panel right-panel" [class.collapsed]="isRightCollapsed">
      @if (isRightCollapsed) {
        <button
          mat-icon-button
          class="toggle-button"
          (click)="toggleRight()"
          [title]="isRightCollapsed ? 'Show panel' : 'Hide panel'"
        >
          <mat-icon>{{ isRightCollapsed ? 'chevron_left' : 'chevron_right' }}</mat-icon>
        </button>
      }

      <div class="panel-content-wrapper">
        <ng-content select="[right-panel]"></ng-content>
      </div>
    </aside>
  }
</div>
